// Bio credentials — stores only identity info (airline, scco) needed to
// reconstruct the app session after Face ID succeeds. The Supabase refresh
// token lives in localStorage under Supabase's own key and is already
// persisted; we don't need to duplicate it here.
// Using localStorage avoids SecureStorage's keychain prompt on write,
// which caused the "Enable Face ID" button to hang silently on iOS.

const KEY = 'sa_bio_creds';

export async function saveBioCreds({ airline, sccoId, partnerName, scco }) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      airline,
      sccoId:      sccoId      || null,
      partnerName: partnerName || null,
      scco:        scco        || null,
    }));
  } catch {}
}

export async function loadBioCreds() {
  try {
    const val = localStorage.getItem(KEY);
    return val ? JSON.parse(val) : null;
  } catch { return null; }
}

export async function clearBioCreds() {
  try { localStorage.removeItem(KEY); } catch {}
}
